<lib-card
	[title]="'Diary record'"
	[isForm]="true"
	[subtitle]="'Every great transformation starts with a single entry — track your journey with diary.'"
>
	<div>
		<ui-text-area-form-field
			[placeholder]="'Write diary text'"
			[valueAsSignal]="diaryText"
			[enableEmoji]="true"
			[enableGenAi]="true"
			[genAiClientContext]="sharedData()?.data"
		></ui-text-area-form-field>
	</div>
	<ui-form-save-button
		class="push-top-md"
		[removeDivider]="true"
		[title]="'Save'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</lib-card>

<div class="push-top">
	@if (diaryItems(); as diaryItems) { @for (diaryItem of diaryItems; track diaryItem.item.id; let first = $first; let
	last = $last) {

	<div>
		<div libFlexRow>
			<div libFlexColumn [libFlexSize]="'fill'">
				<h3>{{ diaryItem.date }}</h3>
			</div>
			<div libFlexColumn>
				<lib-button-list [buttons]="diaryItem.buttons" [mode]="'single'"></lib-button-list>
			</div>
		</div>
		<div class="push-top-sm" [innerHTML]="diaryItem.item.text | textToHtml"></div>
	</div>

	@if (!last) {
	<lib-divider class="push-top push-bottom"></lib-divider>
	} } } @if (diaryItems()?.length === 0) {
	<lib-message [type]="'noDataOnBody'">There are no diary records</lib-message>
	}
</div>
